
// ── Replace with your actual backend base URL (from env / config) ────────────
const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export const LocationService = {
  /**
   * Reverse-geocodes a coordinate pair via your backend proxy using POST.
   */
  reverseGeocode: async (lat, lng) => {
    try {
      if (!API_BASE_URL) {
        throw new Error("Base URL is missing. Check your .env configuration.");
      }
      
      const localizedUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL : `${API_BASE_URL}/`;
      const url = `${localizedUrl}reverse-geocode`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ lat, lng }),
      });
 
      if (!response.ok) {
        let errorMessage = 'Failed to fetch address from backend proxy';
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (parseError) {
          errorMessage = `HTTP Error ${response.status}: ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      const data = await response.json();
      return data;
      
    } catch (error) {
     // FIX: Instead of throwing a fatal error, log a warning and return a safe fallback.
      // This prevents the React Native UI from crashing and allows manual entry.
      console.warn('Backend Geocoding Warning (Handled gracefully):', error.message);
      
      return {
        status: "ERROR_HANDLED",
        results: [
          {
            formatted_address: "Address unavailable. Please enter manually.",
            address_components: [
              { long_name: "Unknown Location", types: ["locality"] }
            ]
          }
        ],
        // Adding a flat data structure fallback in case your hook parses it directly
        data: {
          fullAddress: "Address unavailable. Please enter manually.",
          city: "Unknown Location"
        }
      };
    }
  },

  /**
   * Fetches autocomplete predictions from your backend proxy.
   */
  searchPlaces: async (input, sessiontoken) => {
    try {
      if (!API_BASE_URL) throw new Error("Base URL is missing.");
      
      const localizedUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL : `${API_BASE_URL}/`;
      const url = `${localizedUrl}places-search?input=${encodeURIComponent(input)}&sessiontoken=${sessiontoken}`;
      console.log('url', url)
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
      });
     console.log('responce places ', response)
      // Implement robust error parsing similar to reverseGeocode
      if (!response.ok) {
        let errorMessage = `Search failed with status: ${response.status}`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (parseError) {
          errorMessage = `HTTP Error ${response.status}: Backend Service Unavailable`;
        }
        throw new Error(errorMessage);
      }

      const json = await response.json();
      console.log('📦 [API RESPONSE]: Places search fetched successfully.', json);
      return json?.predictions || json?.data?.predictions || [];
    } catch (error) {
      console.warn('Backend Places Search Error:', error);
      // Return an empty array instead of throwing to prevent UI crashes during typing
      return []; 
    }
  },

  /**
   * Fetches specific place details from your backend proxy.
   */
  getPlaceDetails: async (placeId, sessiontoken) => {
    try {
      if (!API_BASE_URL) throw new Error("Base URL is missing.");
      
      const localizedUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL : `${API_BASE_URL}/`;
      const url = `${localizedUrl}place-details?placeId=${placeId}&sessiontoken=${sessiontoken}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
      });
    
      // Implement robust error parsing
      if (!response.ok) {
        let errorMessage = `Place details failed with status: ${response.status}`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (parseError) {
          errorMessage = `HTTP Error ${response.status}: Backend Service Unavailable`;
        }
        throw new Error(errorMessage);
      }

      const json = await response.json();
      console.log('📦 [API RESPONSE]: Place details fetched successfully.', json);
      return json?.result || json?.data?.result || json;
    } catch (error) {
      console.error('Backend Place Details Error:', error);
      throw error;
    }
  }
};